var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubSelection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83585 2.23763L3.71083 3.97448C2.82077 4.34924 2.37575 4.53661 2.12537 4.9137C1.875 5.29078 1.875 5.77365 1.875 6.73939V16.125H4.125V8.625C4.125 7.9179 4.125 7.56435 4.34467 7.34467C4.56434 7.125 4.91789 7.125 5.625 7.125H12.375C13.0821 7.125 13.4356 7.125 13.6553 7.34467C13.875 7.56435 13.875 7.9179 13.875 8.625V16.125H16.125V6.73939C16.125 5.77365 16.125 5.29078 15.8747 4.9137C15.6242 4.53661 15.1793 4.34924 14.2892 3.97448L10.1642 2.23763C9.59003 1.99588 9.30292 1.875 9 1.875C8.69708 1.875 8.40997 1.99588 7.83585 2.23763Z",
    stroke: "#353535",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.875H9.75",
    stroke: "#353535",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.625H8.25C7.5429 11.625 7.18934 11.625 6.96967 11.8447C6.75 12.0644 6.75 12.4179 6.75 13.125V14.625C6.75 15.3321 6.75 15.6856 6.96967 15.9053C7.18934 16.125 7.5429 16.125 8.25 16.125H9.75C10.4571 16.125 10.8106 16.125 11.0303 15.9053C11.25 15.6856 11.25 15.3321 11.25 14.625V13.125C11.25 12.4179 11.25 12.0644 11.0303 11.8447C10.8106 11.625 10.4571 11.625 9.75 11.625Z",
    stroke: "#353535",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubSelection);
export default __webpack_public_path__ + "static/media/hub-selection.ff6baf8c26e4969ad6e76cdd35dffc08.svg";
export { ForwardRef as ReactComponent };